// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1782477680648
      var cssReload = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  